import { createIcon } from '@chakra-ui/react'

export const Drag = createIcon({
    displayName: 'Drag',
    viewBox: '0 0 16 6',
    d: 'M16 0H0V2H16V0ZM0 6H16V4H0V6Z',
})
